import {
  Avatar,
  Box,
  Button,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import { ControlledSelectCheckmark } from 'Components/ControlledSelectCheckmark';
import { DoctorsSuppliersContext } from 'Context/SuppliersContext/DoctorsSuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SUPPLIERS_RESOURCES } from 'Enum/suppliers';
import { useDictionary } from 'Hooks';
import { PurpleX } from 'Images';
import { IDoctorsSuppliers } from 'Interfaces/doctorsSuppliers';
import { ReactNode, useContext } from 'react';
import { useFormContext } from 'react-hook-form';

const Languages = () => {
  const { resources } = useContext(DoctorsSuppliersContext);

  const { setValue, watch } = useFormContext<IDoctorsSuppliers>();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Suppliers
  ).doctorsSearchForm;

  return (
    <Stack
      gap='20px'
      sx={{
        '.MuiSvgIcon-root > path': {
          strokeWidth: '0.833333',
          stroke: '#A020FF',
        },
      }}
    >
      <Typography variant='body2'>{dictionary.languages}</Typography>
      <Box
        position={'relative'}
        sx={{
          '.MuiSelect-icon': {
            visibility:
              watch('lng') && watch('lng')!.length > 0 ? 'hidden' : 'visible',
          },
        }}
      >
        <ControlledSelectCheckmark
          ariaLabel={dictionary.languagesPlaceholder}
          selectedText={
            (watch('lng') || []).length === 1
              ? (resources[SUPPLIERS_RESOURCES.language]?.resources || []).find(
                  (lang) => lang.resourceId === watch('lng')![0]
                )?.content
              : `${dictionary.chosen} ${(watch('lng') || []).length} ${
                  dictionary.languages
                }`
          }
          placeholder={dictionary.languagesPlaceholder}
          options={(
            resources[SUPPLIERS_RESOURCES.language]?.resources || []
          ).map((language) => language.content)}
          selected={(watch('lng') || [])
            .map(
              (language) =>
                (resources[SUPPLIERS_RESOURCES.language]?.resources || []).find(
                  (d) => d.resourceId === language
                )?.content || ''
            )
            .filter((language) => language !== '')}
          onChange={(event: SelectChangeEvent<string[]>, child: ReactNode) => {
            setValue(
              'lng',
              (
                (typeof event.target.value === 'string'
                  ? [event.target.value]
                  : event.target.value) || []
              )
                .map(
                  (language) =>
                    (
                      resources[SUPPLIERS_RESOURCES.language]?.resources || []
                    ).find((d) => d.content === language)?.resourceId || -1
                )
                .filter((language) => language !== -1)
            );
          }}
          size={'small'}
          maxHeight={273}
        />
        {watch('lng') && watch('lng')!.length > 0 && (
          <Button
            onClick={() => {
              setValue('lng', []);
            }}
            sx={{
              height: '40px',
              width: '40px',
              minWidth: '40px',
              position: 'absolute',
              top: '0px',
              right: '4px',
              backgroundColor: 'white',
              zIndex: 1,
            }}
          >
            <Avatar
              alt={dictionary.resetLanguages}
              src={PurpleX}
              sx={{ width: '20px', height: '20px' }}
            />
          </Button>
        )}
      </Box>
    </Stack>
  );
};

export default Languages;
